import { LazyImage as _LazyImage } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const LIItem = styled.li<{ columnNum: number }>`
  display: flex;
  width: ${({ columnNum }) => (columnNum > 0 ? `calc(100% / ${columnNum})` : `100%`)};
  min-height: 46.5px;
`;

export const AnchorItem = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 15px;
`;

export const DivTextWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const LazyImage = styled(_LazyImage)`
  padding-right: 7.5px;
`;
